import { render } from "./PaymentStatus.vue?vue&type=template&id=d70a66b4&ts=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=ts"
export * from "./PaymentStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__